module.exports = __webpack_public_path__ + "img/1528427707.75a28730.jpg";